import React, { useState, useEffect } from 'react';
import { Auth } from 'aws-amplify';

export default function NavBar() {
	const [ user, setUser ] = useState(null);
	useEffect(() => {
		Auth.currentAuthenticatedUser().then((res) => {
			setUser(res.attributes.email);
		});
	}, []);
	return (
		<header class="sticky top-0 z-50">
			<nav className="flex items-center justify-between flex-wrap bg-teal-500 p-6">
				<div className="flex items-center flex-shrink-0 text-white mr-6">
					<a href="/">
						<span className="font-semibold text-xl tracking-tight">Brazil CW</span>
					</a>
				</div>
				<div className="w-full block flex-grow lg:flex lg:items-center lg:w-auto">
					<div className="text-sm lg:flex-grow" />
					<div className="mr-1">{user}</div>

					<div>
						<div
							onClick={() => {
								console.log('logging out');
								Auth.signOut();
								setTimeout(() => {
									window.location.reload(false);
								}, 1000);
							}}
							className="inline-block cursor-pointer text-sm px-4 py-2 leading-none border rounded text-white border-white hover:border-transparent hover:text-teal-500 hover:bg-white mt-4 lg:mt-0"
						>
							Sign out
						</div>
					</div>
				</div>
			</nav>
		</header>
	);
}
